import { __extends, __decorate } from 'tslib';
import { Component, Vue } from 'vue-property-decorator';

/**
 * Компонент подложки модального окна. Затемняет фон, занимает все пространство окна, имеет фиксированное позиционирование.
 *
 * В обычной ситуации создаётся автоматически при использовании HseModal, ручное использование не требуется.
 *
 * В примере ниже компонент уменьшен и статично позиционирован для демонстрации
 * ```vue live
 * <HseModalOverlay :style="{ position: 'static', width: '200px', height: '200px' }" />
 * ```
 */
var HseModalOverlay = /** @class */ (function (_super) {
    __extends(HseModalOverlay, _super);
    function HseModalOverlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HseModalOverlay = __decorate([
        Component({
            name: 'HseModalOverlay',
        })
    ], HseModalOverlay);
    return HseModalOverlay;
}(Vue));

export default HseModalOverlay;
